module.exports = __webpack_public_path__ + "img/estimateIcon.02c9bb98.svg";